import React, { useContext, useCallback } from "react";

import GameBoardCell from "./Cell";
import GameBoardPort from "./Port";
import GameContext from "../Context";

import "./Board.scss";

function makePorts() {
  return new Array(32).fill({}).map((_, n) => {
    const ordinal = n + 1;
    const direction = ordinal <= 8 ? "SOUTH" : ordinal <= 16 ? "WEST" : ordinal <= 24 ? "NORTH" : "EAST";
    return <GameBoardPort ordinal={ordinal} direction={direction} key={ordinal} />;
  });
}

function GameBoard() {
  const { engine } = useContext(GameContext);

  const makeCells = useCallback(() => {
    const cells = [];

    for (let y = 0; y < 8; y += 1) {
      for (let x = 0; x < 8; x += 1) {
        const hasGuess = engine.hasGuessAt({ x, y });
        const hasBall = engine.hasBallAt({ x, y });
        const steps = engine.getRevealedStepsFor({ x, y });
        cells.push(
          <GameBoardCell
            x={x}
            y={y}
            hasGuess={hasGuess}
            hasBall={hasBall}
            steps={steps}
            key={x * 8 + y}
            pathActive={engine.arePathsRevealed()}
          />
        );
      }
    }
    return cells;
  }, [engine]);

  return (
    <div className="game-board">
      {makePorts()}
      {makeCells()}
    </div>
  );
}

export default GameBoard;
